import React from "react";
import styled from "styled-components/macro";
import top from "../../images/ride/top.png";
import top_side_pillar from "../../images/ride/top_side_pillar.png";
import bottom_right_pillar from "../../images/ride/bottom_right_pillar.png";
import bottom_left_pillar from "../../images/ride/bottom_left_pillar.png";
import bottom from "../../images/ride/bottom.png";
import right_inner_pillar from "../../images/ride/right_inner_pillar.png";
import left_inner_pillar from "../../images/ride/left_inner_pillar.png";
import small_holder from "../../images/ride/small_holder.png";

const getWidth = (size, type) => {
  if (size === 4 || (type === "bicycle" && size === 3)) {
    return 525;
  }
  return 400;
};

const getShelfWidth = (size, type) => {
  if (size === 4 || (type === "bicycle" && size === 3)) {
    return 516;
  }
  return 385;
};

const RideUnitWrapper = (props) => {
  return (
    <Wrapper size={props.size} type={props.type}>
      <TopImg src={top} size={props.size} type={props.type} />
      <Items type={props.type}>{props.children}</Items>

      <TopPillars>
        <TopPillarLeft>
          <img src={top_side_pillar} alt="pillar" />
        </TopPillarLeft>
        <TopPillarRight>
          <img src={top_side_pillar} alt="pillar" />
        </TopPillarRight>
      </TopPillars>
      <MiddleBar>
        <HolderImg
          left={props.size === 4 ? 52 : props.type === "scooter" ? 54 : 100}
          src={small_holder}
        />
        <HolderImg
          left={props.type === "scooter" ? 99 : 120}
          src={small_holder}
        />
        {(props.type === "scooter" || props.size > 2) && (
          <HolderImg
            left={props.type === "scooter" ? 99 : 120}
            src={small_holder}
          />
        )}
        {props.size === 4 && <HolderImg left={98} src={small_holder} />}
      </MiddleBar>
      <BottomPillars>
        <LeftBottomPillar>
          <BottomPillarImg src={bottom_left_pillar} />
        </LeftBottomPillar>
        <RightBottomPillar>
          <BottomPillarImg src={bottom_right_pillar} />
        </RightBottomPillar>
      </BottomPillars>
      <LeftInnerPillar src={left_inner_pillar} />
      <RightInnerPillar src={right_inner_pillar} />
      <Bottom src={bottom} />
    </Wrapper>
  );
};

export { RideUnitWrapper };

const Wrapper = styled.div`
  // width:100%;
  width: ${(props) => getWidth(props.size, props.type)}px;
`;

const TopImg = styled.img`
  width: ${(props) => getShelfWidth(props.size, props.type)}px;
  margin-left: ${(props) => {
    if (getShelfWidth(props.size, props.type) === 385) return 8;
    return 4;
  }}px;
  height: 42px;
`;

const TopPillars = styled.div`
  display: flex;
  flex: auto;
  position: relative;
  align-content: space-between;
  margin-top: -20px;
  width: 100%;
  padding-right: 8px;
  padding-left: 8px;
`;

const BottomPillars = styled.div`
  display: flex;
  flex: auto;
  position: relative;
  align-content: space-between;
  margin-top: -24px;
  width: 100%;
`;

const TopPillarRight = styled.div`
  margin-left: auto;
`;

const TopPillarLeft = styled.div`
  margin-right: auto;
`;

const RightBottomPillar = styled.div`
  margin-left: auto;
  height: 256px;
`;

const LeftBottomPillar = styled.div`
  margin-right: auto;
  height: 256px;
`;

const Bottom = styled.img`
  position: absolute;
  bottom: 3px;
  width: 100%;
  height: 50px;
  z-index: -3;
`;

const LeftInnerPillar = styled.img`
  position: absolute;
  bottom: 21px;
  left: 28px;
  z-index: -2;
  height: 229px;
`;

const RightInnerPillar = styled.img`
  position: absolute;
  bottom: 21px;
  right: 28px;
  z-index: -2;
  height: 229px;
`;

const MiddleBar = styled.div`
  position: absolute;
  top: 100px;
  width: 95%;
  margin-left: 2.5%;
  height: 14px;
  z-index: -1;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #dcdcdc;
  background-image: linear-gradient(to bottom, #ededed, #e0e0e0);
`;

const Items = styled.div`
  position: absolute;
  top: -6px;
  left: ${(props) => (props.type === "bicycle" ? 24 : 8)}px;
  width: 100%;
`;

const BottomPillarImg = styled.img`
  object-fit: fill;
  height: 256px;
`;

const HolderImg = styled.img`
  margin-top: -4px;
  margin-left: ${(props) => props.left}px;
`;
